import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedCategory: null,
  isFormOpen: false,
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    clearSelectedCategory: (state) => {
      state.selectedCategory = null;
    },
    toggleForm: (state) => {
      state.isFormOpen = !state.isFormOpen;
    },
  },
});

export const { setSelectedCategory, clearSelectedCategory, toggleForm } =
  categorySlice.actions;

export default categorySlice.reducer;
  